/**
 * Payment method interfaces and implementations for the application.
 * Supports Cash, Invoice, Tab payment methods and is designed to be extensible
 * for future payment service provider integration.
 */

// Base interface for all payment methods
export interface PaymentMethod {
  id: PaymentMethodType;
  name: string;
  description: string;
  icon?: string;
  isAvailable: boolean;
  requiresExternalProcessing?: boolean;
}

// Enum for payment method types
export enum PaymentMethodType {
  CASH = 'CASH',
  INVOICE = 'INVOICE',
  TAB = 'TAB',
  // Reserved for future payment service provider integration
  PAYMENT_SERVICE = 'PAYMENT_SERVICE',
}

// Cash payment method implementation
export const CashPaymentMethod: PaymentMethod = {
  id: PaymentMethodType.CASH,
  name: 'Bar',
  description: 'Bezahlung mit Bargeld',
  isAvailable: true,
  requiresExternalProcessing: false,
};

// Invoice payment method implementation
export const InvoicePaymentMethod: PaymentMethod = {
  id: PaymentMethodType.INVOICE,
  name: 'Rechnung',
  description: 'Bezahlung per Rechnung',
  isAvailable: true,
  requiresExternalProcessing: true,
};

// Tab payment method implementation
export const TabPaymentMethod: PaymentMethod = {
  id: PaymentMethodType.TAB,
  name: 'Deckel',
  description: 'Auf den Deckel schreiben',
  isAvailable: true,
  requiresExternalProcessing: true,
};

// List of all available payment methods
export const availablePaymentMethods: PaymentMethod[] = [
  CashPaymentMethod,
  InvoicePaymentMethod,
  TabPaymentMethod,
];

// Helper function to get a payment method by ID
export const getPaymentMethodById = (id: string): PaymentMethod | undefined => {
  return availablePaymentMethods.find(method => method.id === id);
};

// Update the Sale interface to include payment method information
// This is just a type definition - the actual interface is in Sale.ts
export interface SaleWithPaymentMethod {
  paymentMethod?: string;
  paymentReference?: string;
}
